import React from "react";
import styles from "./ArenaSkeleton.module.scss";

export const ArenaSkeleton: React.FC = () => {
  return (
    <div className={styles.arenaListWrapper}>
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className={styles.arenaItem}>
          <div className={styles.arenaItemText} />
          <div className={styles.arenaItemArrow} />
        </div>
      ))}
    </div>
  );
};
